module.exports = __webpack_public_path__ + "static/media/ship-inside.9b669f4e.png";